import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LangLayout from "./components/LangLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Training from "./pages/Training";
import Products from "./pages/Products";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./contexts/AuthContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

/** Browser-based language detection on first visit to "/". */
function detectPreferredLang() {
  try {
    const stored = localStorage.getItem("lsp_lang");
    if (stored && ["en", "or", "hi"].includes(stored)) return stored;
    const n = (navigator.language || "").toLowerCase();
    if (n.startsWith("or")) return "or";
    if (n.startsWith("hi")) return "hi";
  } catch {}
  return "en";
}

function LangRedirect() {
  const lang = detectPreferredLang();
  return <Navigate to={`/${lang}`} replace />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin — no language prefix */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />

              {/* Language-prefixed pages */}
              <Route path="/:lang" element={<LangLayout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="services" element={<Services />} />
                <Route path="training" element={<Training />} />
                <Route path="products" element={<Products />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog/:slug" element={<BlogDetail />} />
                <Route path="contact" element={<Contact />} />
              </Route>

              {/* Default → detect lang and redirect */}
              <Route path="/" element={<LangRedirect />} />
              {/* Legacy unprefixed paths → /en/<path> */}
              <Route path="*" element={<LegacyRedirect />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </div>
    </HelmetProvider>
  );
}

function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  const lang = detectPreferredLang();
  // Avoid re-prefixing already-prefixed
  return <Navigate to={`/${lang}${pathname}${search}${hash}`} replace />;
}

export default App;
